export const tourTypeList = [
  { nameEn: 'All tour types', nameFr: 'Tous les types de circuits', value: '-1' },
  { nameEn: 'Adventure tours', nameFr: "Circuits d'aventures", value: '45' },
  { nameEn: 'Agritourism', nameFr: 'Agrotourisme', value: '7' },
  { nameEn: 'City tours', nameFr: "Tour d'une ville", value: '13' },
  { nameEn: 'Classic Europe', nameFr: "Classiques d'Europe", value: '23' },
  { nameEn: 'Cruise', nameFr: 'Croisière', value: '5' },
  { nameEn: 'European beach holidays', nameFr: 'Circuits balnéaires en Europe', value: '43' },
  { nameEn: 'European island hopping', nameFr: "Les îles d'Europe", value: '17' },
  { nameEn: 'Fly and Drive tours', nameFr: 'Circuits vols et voiture', value: '19' },
  { nameEn: 'Fly and Rail tours', nameFr: 'Circuits vols et train', value: '27' },
  { nameEn: 'Guided tours', nameFr: 'Circuits guidés', value: '33' },
  { nameEn: 'Pilgrimage', nameFr: 'Pèlerinage', value: '1' },
  { nameEn: 'Premium tours', nameFr: 'Circuits haut de gamme', value: '41' },
  { nameEn: 'Romance', nameFr: 'Romance', value: '3' },
  { nameEn: 'RV experiences', nameFr: 'Expériences VR', value: '35' },
  { nameEn: 'Shows & sports events', nameFr: 'Circuit sports & spectacles', value: '9' },
  { nameEn: 'Ski vacations', nameFr: 'Vacances de ski', value: '37' },
  { nameEn: 'Sport adventure', nameFr: 'Aventure sportive', value: '11' },
  { nameEn: 'Two cities tour', nameFr: 'Circuit deux villes', value: '15' },
  { nameEn: 'Urban Tours', nameFr: 'Circuits urbains', value: '47' }
];

export const guideList = [
  { nameEn: 'With or without a guide', nameFr: 'Avec ou sans accompagnateur', value: 'ALL' },
  { nameEn: 'Guided tours only', nameFr: 'Circuits guidés seulement', value: 'FULLY' },
  { nameEn: 'Partially guided tours only', nameFr: 'Circuits partiellement guidés seulement', value: 'PARTIALLY' },
  { nameEn: 'Self-guided tours only', nameFr: 'Circuits non-accompagnés seulement', value: 'SELF' }
];

export const TOUR_5_TO_10 = 7;
export const TOUR_11_TO_16 = 14;
export const TOUR_17_OR_MORE = 21;
